var d3 = {
  ...require("d3-selection/dist/d3-selection.min"),
};
var nav = d3.select('nav');
var icon = nav.select(".ham_icon");
var content = nav.select(".hamburgerContent");

//when hamburger icon is clicked, switch content display on and off
icon.on("click", function(d){
	// content.classed("hidden", content.classed("hidden") ? false : true);
	var direction = content.style('width') == "75%" ? 'closing' : 'opening';
	closeOpenHamMenu(direction)

	// var focus = direction == 'closing' ? false : true;
	resetHamIcon(direction, true);
});

icon.on('keydown', function(e){
	if(e.key == 'Enter'){
		e.preventDefault();
		this.click();
	}
});

// //when links that are not dropdowns are clicked, switch content display on and off
nav.selectAll('a').on("click", function(){
	var direction = content.style('width') == "75%" ? 'closing' : 'opening';

	closeOpenHamMenu(direction);
	resetHamIcon(direction, false);
});

//hide and show submenus
d3.selectAll('.dropdownIcon').on("click", function(){
	var dropdownMenu = d3.select(this.parentNode.parentNode).select(".dropdownMenu");
	dropdownMenu.classed("hidden", dropdownMenu.classed("hidden") ? false : true);
});

//hide the ham menu when the body text is clicked
d3.selectAll('#top, .main').on('click', function(d){
	var dropdownMenus = d3.selectAll('.dropdownMenu');
	dropdownMenus.each(function(d){
		if(!d3.select(this).classed('hidden')){
			d3.select(this).classed('hidden', true);
		}
	});
	document.querySelector('.main').classList.remove('noscroll');
	document.querySelector('#top').classList.remove('noscroll');
	content.style('width', '0%');
	content.style('display', 'none');

	resetHamIcon('closing', false);
});


// keep tabbing in the hamburger menu. Last element tabs to the ham icon. Ham icon
// shift+tabs to the last element.
var links = nav.selectAll('a.top-level-dropdown').nodes(),
	links_length = links.length;

document.addEventListener('keydown', (e)=> {
	//tab only
	if(e.key == 'Tab' && !e.shiftKey){

		//tab from the ham icon, reset ham icon styling
		if(e.target.classList.contains('ham_icon')){

			if(content.style('display') == "block"){
				resetHamIcon('opening', false);
			}else{			
				resetHamIcon('closing', false);
			}
		}
		//if the tabbing from the last element in the list, move focus to ham icon
		if(e.target == links[links_length-1]){
			e.preventDefault();
			document.getElementsByClassName('ham_icon')[0].focus();
			resetStyles(links[links_length-1].closest('.dropdownTitlediv'));
			resetHamIcon('opening', true);
			}

	// shift+tab
	}else if(e.key == "Tab" && e.shiftKey){
		// console.log(e.target)
		// add focus styling to ham icon when shift tabbing TO it and
		// reset the style on the first item on the list 
		if(e.target == links[0]){
			resetHamIcon('opening', true);
			resetStyles(links[0].closest('.dropdownTitlediv'));
		}
		
		//when shift tabbing FROM the ham icon
		if(e.target.classList.contains('ham_icon')){
			// move focus to the last item on the list a reset ham icon style 
			// if the menu is open
			if(content.style('display') != 'none'){
				e.preventDefault();		
				links[links_length-1].focus();
				resetHamIcon('opening', false);

			// reset ham icon style if the menu is closed
			}else if(content.style('display') == 'none'){
				resetHamIcon('closing', false);
			}
		}

	//close everything with the escape key	
	}else if(e.key == "Escape" && content.style('width') == "75%"){
		closeOpenHamMenu('closing');
		resetHamIcon('closing', false);
	}
	
});

//disable tabbing in the nav menu when it's closed. the following is a
// listener for any changes to the targetNode 

// Select the node that will be observed for mutations
const targetNode = document.getElementById('hamburgerDiv');

// Options for the observer (which mutations to observe)
const config = {attributes: true};

// Callback function to execute when mutations are observed
const callback = function(mutationsList, observer) {
		if(document.getElementById('hamburgerDiv').style.width == '0px'){
			content.style('display', 'none');
		
		}else if(document.getElementById('hamburgerDiv').style.width == '75%'){
			content.style('display', 'block');
		}
};

// Create an observer instance linked to the callback function
const observer = new MutationObserver(callback);

// Start observing the target node for configured mutations
observer.observe(targetNode, config);

///FOCUS STYLING///
/// focus styling is done here instead of in CSS because the focus goes to the overarching 
// div but the p element inside it, and the dropdown arrow also need style changes even though
// they're not specifically focused

	var a_links = document.querySelectorAll('.hamburgerContent a'),
		titleDivs = document.querySelectorAll('.dropdownTitlediv'),
		dropdownIcons = document.querySelectorAll('.dropdownIcon'),	
		title_div_style_focused = {"background-color":'#FFFFFF', border: "2px solid #005DA4"},
		title_div_style_unfocused = {"background-color":'#005DA4', border: "0.5px solid #FFFFFF"},
		title_div_p_style_focused = {color:"#005DA4", outline:"2px solid #005DA4",padding:"0.2rem"},
		p_unfocused = {color:"#FFFFFF", outline:"none",padding:"0.2rem"},
		a_link_style_focused = {"background-color":'#FFFFFF', border: "2px solid #005DA4"},
		a_link_style_unfocused = {"background-color":'#005DA4'},
		dropdown_icon_style_focused = {'background-color':'#FFFFFF', outline: 'none', border: "2px solid #005DA4",padding:"0.5rem"},
		dropdown_icon_style_unfocused = {'background-color':'#005DA4', outline: 'none', border: "none",padding:"0"},
		ham_icon_style_focused = {'background-color':'#FFFFFF', border:"2px solid #005DA4", padding: '0 1.1rem'},
		ham_icon_style_unfocused = {'background-color':'#005DA4',border:"none", padding: '0 1.1rem'};		
	
	// console.log(a_links);
	
	a_links.forEach((link)=>{
		// console.log('link', link);

		if(link.classList.contains('top-level-dropdown')){
			var titleDiv = link.closest('.dropdownTitlediv');
		}

		link.addEventListener('focus', function(){
			
			//reset all colors to default
			a_links.forEach((element)=>{
				if(!element.classList.contains('top-level-dropdown')){
					resetStyles(element);
				}
			});
			titleDivs.forEach((element)=>{
				resetStyles(element);
			});

			//find the associated p text
			var p_element = link.querySelector('p');
			
			//change only the focused elements
			if(titleDiv){
				Object.assign(titleDiv.style, title_div_style_focused);

				//need the blue border around the p text to distiguish focus on p from focus on dropdown arrow
				Object.assign(p_element.style,title_div_p_style_focused);

				if(titleDiv.querySelector('.dropdownIcon')){
					dropdown_icon = titleDiv.querySelector('.dropdownIcon')
					dropdown_icon.querySelector('path').setAttribute('fill','#005DA4');
					dropdown_icon.style['background-color'] = "#FFFFFF";
				}
			}else{
				Object.assign(link.style,a_link_style_focused);
				Object.assign(p_element.style,{color:"#005DA4"}); // no border around text needed bec no dropdown arrow
			}
		});
	});

	dropdownIcons.forEach((icon)=>{
		var titleDiv = icon.closest('.dropdownTitlediv');

		icon.addEventListener('focus', function(){

			//reset all colors to default
			titleDivs.forEach((div)=>{
				resetStyles(div);
			});
			a_links.forEach((element)=>{
				if(!element.classList.contains('top-level-dropdown')){
					resetStyles(element);
				}
			});

			// change div and icon style
			Object.assign(titleDiv.style,title_div_style_focused);
			titleDiv.querySelector('p').style.color = '#005DA4';
			icon.querySelector('path').setAttribute('fill','#005DA4');
			Object.assign(icon.style, dropdown_icon_style_focused);
		});
	});

	/// can't call the resetHamIcon function here because the text of the button depends on the scenario
	/// this just sets the style
	document.querySelector('.ham_icon').addEventListener('focus', function(){
		Object.assign(this.style, ham_icon_style_focused);
		this.querySelector('p').style.color = "#005DA4";
	});


	function closeOpenHamMenu(direction){
		if(direction == 'opening'){
			content.style('width', '75%');
			document.querySelector('.main').classList.add('noscroll');
			document.querySelector('#top').classList.add('noscroll');
		}else{
			content.style('width', '0');
			document.querySelector('.main').classList.remove('noscroll');
			document.querySelector('#top').classList.remove('noscroll');
			
			//close all dropdown menus
			document.querySelectorAll('.dropdownMenu').forEach((menu)=>{
				if(!menu.classList.contains('hidden')){
					menu.classList.add('hidden');
				}
			});

			document.querySelectorAll('.dropdownTitlediv').forEach((div)=>{
				resetStyles(div);
			});

			document.querySelectorAll('.hamburgerContent a').forEach((element)=>{
				if(!element.classList.contains('top-level-dropdown')){
					resetStyles(element);
				}
			});
		}
	}

	function resetStyles(element){
		
		// if it's a top level div, add the white border
		if(element.classList.contains('dropdownTitlediv')){
			Object.assign(element.style,title_div_style_unfocused);
		}else{
			Object.assign(element.style, a_link_style_unfocused);
		 }

		 //change p text back to white and remove the border
		var p_element = element.querySelector('p');
		Object.assign(p_element.style,p_unfocused);

		//reset dropdown icon 
		if(element.querySelector('.dropdownIcon')){
			var path = element.querySelector('.dropdownIcon').querySelector('path'),
				icon = element.querySelector('.dropdownIcon');
			path.setAttribute('fill','#FFF');
			Object.assign(icon.style, dropdown_icon_style_unfocused);
		}
	}

	function resetHamIcon(direction, focus){
		var ham_icon = document.querySelector('.ham_icon');

		if(direction== 'opening'){
			d3.select('.ham_icon p').text('CLOSE').attr('class', 'close_button');
		}else if(direction == 'closing'){
			d3.select('.ham_icon p').text('').attr('class', 'fa fa-bars');
		}
				
		if(focus == false){
			Object.assign(ham_icon.style, ham_icon_style_unfocused);
			ham_icon.querySelector('p').style.color = "#FFFFFF";
		}else if(focus == true){
			Object.assign(ham_icon.style, ham_icon_style_focused);
			ham_icon.querySelector('p').style.color = "#005DA4";
		}
	}